<template>
  <div class="down-left" v-cdrag v-if="appMode.offline() || sifApp">
    <NotifyUserBooksRrefresh
      v-if="$store.getters['bookListRefresh/getStatus'] != 'done'"
    />
    <NotifyUserUpdatesProcess v-if="showNotifier" />
    <NotifyUserPrintProcess
      v-if="$store.state.print.show && appMode.offline()"
    />
    <NotifyUserBackup v-if="false && $store.state.backup.showMessage" />
  </div>
</template>

<script>
import NotifyUserBooksRrefresh from "@/components/importantActions/notifyUserBooksRrefresh";
import NotifyUserUpdatesProcess from "@/components/importantActions/NotifyUserUpdatesProcess";
import NotifyUserPrintProcess from "@/components/importantActions/NotifyUserPrintProcess";
import NotifyUserBackup from "@/components/importantActions/NotifyUserBackup";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    NotifyUserBooksRrefresh,
    NotifyUserUpdatesProcess,
    NotifyUserPrintProcess,
    NotifyUserBackup,
  },
  computed: {
    ...mapGetters("updatesCenter", ["showNotifier"]),
  },
  sockets: {
    updatesInProcess: async function (data) {
      this.setStage(data.stage);
      this.setPercentage(data.percentage);
      if (data.stage == 1) this.setQuiet(data.quiet);
      if (data.version) this.setVersion(data.version);

      if (data.info) this.setInfo(data.info);

      if (data.internalDisk) this.setExternalNotConnected(true);
      if (data.multiDisks) this.setMultiDisks(true);
    },
    backupStarted: function (data) {
      this.$store.state.backup.showMessage = true;
    },
    backupSucceed: function (data) {
      this.$store.state.backup.showMessage = false;
    },
    backupFailed: function (data) {
      this.$store.state.backup.showMessage = false;
    },
  },
  methods: {
    ...mapActions("updatesCenter", [
      "setStage",
      "setPercentage",
      "setVersion",
      "setInfo",
      "setInProcess",
      "setExternalNotConnected",
      "setMultiDisks",
      "setQuiet",
    ]),
    sifApp() {
      return globalThis.OTZAR_BASIC_INFO.OTZAR_SIF;
    },
  },
};
</script>

<style scoped>
.down-left {
  position: fixed;
  z-index: 9;
  bottom: 80px;
  left: 40px;
}
</style>
